export enum Direction {
  Left = 'left',
  Right = 'right',
}
